import { Routes } from '@angular/router';
import { AccountSettingsComponent } from './pages/account-settings/account-settings.component';
import { DefaultPageComponent } from './pages/default-page/default-page.component';
import { EmailPrintComponent } from './pages/email-print/email-print.component';
import { EmailsContainerComponent } from './pages/emails/emails-container.component';
import { EmailsSideNavComponent } from './components/emails-sidenav/emails-side-nav.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { ErrorNotExistedPageComponent } from './pages/error-not-existed-page/error-not-existed-page.component';
import { MainComponent } from './components/main/main.component';
import { PluginsComponent } from './pages/plugins/plugins.component';
import { ReportsComponent } from './pages/reports/reports.component';
import { DispatchingRuleComponent } from './pages/settings/dispatching-rule/dispatching-rule.component';
import { MailAccountTagsComponent } from './pages/settings/mail-account-tags/mail-account-tags.component';
import { MailAccountTemplatesComponent } from './pages/settings/mail-account-templates/mail-account-templates.component';
import { MailAccountUsersComponent } from './pages/settings/mail-account-users/mail-account-users.component';
import { MailAccountComponent } from './pages/settings/mail-accounts/mail-account.component';
import { OrganizationGeneralSettingsComponent } from './pages/settings/organization-general-settings/organization-general-settings.component';
import { OrganizationGroupsComponent } from './pages/settings/organization-groups/organization-groups.component';
import { OrganizationUsersComponent } from './pages/settings/organization-users/organization-users.component';
import { OrganizationComponent } from './pages/organizations/organization.component';
import { ProviderComponent } from './pages/providers/provider.component';
import { SettingsComponent } from './components/settings/settings.component';
import { AuthGuard } from './services/auth/auth.guard';
import { RootAuthGuard } from './services/auth/root.auth.guard';
import { MailAccountGeneralSettingsComponent } from './pages/settings/mail-account-general-settings/mail-account-general-settings.component';
import { MailAccountFoldersSettingsComponent } from './pages/settings/mail-account-folders-settings/mail-account-folders-settings.component';
import {
  ROUTES,
  WEB_CODE_ROUTES,
} from '@app-shared/constants/routes/fe.routes';
import { HomePageComponent } from '@app-pages/home-page/home-page.component';
import { TestPageComponent } from '@app-pages/test-page/test-page.component';
import { MailAccountAddressBookComponent } from '@app-pages/settings/mail-account-address-book/mail-account-address-book.component';

const {
  GENERAL,
  USERS,
  MAIL_ACCOUNTS,
  ERRORS,
  ORGANIZATIONS,
  PROVIDERS,
  ORGANIZATION,
  MAIL_ACCOUNT,
  GROUPS,
  RULES,
  FOLDERS,
  ADDRESS_BOOK,
  TEMPLATES,
  TAGS,
  ACCOUNT_SETTINGS,
  EMAILS,
  PLUGINS,
  REPORTS,
  LOGOUT,
} = ROUTES;

const { SERVER_ERROR, REQUEST_ERROR, NOT_EXISTS, UNAUTHORIZED, FORBIDDEN } =
  ERRORS;

export const routes: Routes = [
  {
    path: '',
    component: HomePageComponent,
  },
  {
    path: LOGOUT,
    component: DefaultPageComponent,
  },
  {
    path: FORBIDDEN,
    component: ErrorPageComponent,
  },
  {
    path: UNAUTHORIZED,
    component: ErrorPageComponent,
  },
  {
    path: NOT_EXISTS,
    component: ErrorNotExistedPageComponent,
  },
  {
    path: SERVER_ERROR,
    component: ErrorPageComponent,
  },
  {
    path: REQUEST_ERROR,
    component: ErrorPageComponent,
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: SettingsComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: ORGANIZATIONS,
            component: OrganizationComponent,
            canActivate: [RootAuthGuard],
          },
          {
            path: PROVIDERS,
            component: ProviderComponent,
            canActivate: [RootAuthGuard],
          },
          {
            path: ORGANIZATION,
            canActivate: [AuthGuard],
            children: [
              { path: '', redirectTo: GENERAL, pathMatch: 'full' },
              {
                path: GENERAL,
                component: OrganizationGeneralSettingsComponent,
              },
              { path: MAIL_ACCOUNTS, component: MailAccountComponent },
              { path: USERS, component: OrganizationUsersComponent },
              { path: GROUPS, component: OrganizationGroupsComponent },
            ],
          },
          {
            path: `${ORGANIZATION}/${MAIL_ACCOUNT}/:mailAccountId`,
            canActivate: [AuthGuard],
            children: [
              { path: '', redirectTo: GENERAL, pathMatch: 'full' },
              { path: GENERAL, component: MailAccountGeneralSettingsComponent },
              { path: USERS, component: MailAccountUsersComponent },
              { path: RULES, component: DispatchingRuleComponent },
              { path: TAGS, component: MailAccountTagsComponent },
              { path: TEMPLATES, component: MailAccountTemplatesComponent },
              { path: FOLDERS, component: MailAccountFoldersSettingsComponent },
              {
                path: ADDRESS_BOOK,
                component: MailAccountAddressBookComponent,
              },
            ],
          },
        ],
      },
      {
        path: EMAILS,
        component: EmailsContainerComponent,
        canActivate: [AuthGuard],
      },
      {
        path: REPORTS,
        component: ReportsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: PLUGINS,
        component: PluginsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: ACCOUNT_SETTINGS,
        component: AccountSettingsComponent,
        canActivate: [AuthGuard],
      },
    ],
  },
  {
    path: MAIL_ACCOUNTS,
    component: EmailsSideNavComponent, /// ???? need
    canActivate: [AuthGuard],
  },
  {
    path: `${MAIL_ACCOUNT}/:mailAccountId/mail-folder/:mailFolderId/emails-content/:emailId/print`,
    component: EmailPrintComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'testerror',
    component: TestPageComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    component: ErrorPageComponent,
  },
];

export const redirectRoutes: Routes = WEB_CODE_ROUTES.map(path => ({
  path,
  redirectTo: '/',
  pathMatch: 'prefix',
}));
